import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";

const Body = styled(Box)(({ theme }) => ({
  borderRadius: "28px",
  backgroundColor: "rgba(255,255,255,0.16862745098039217 )",
  display: "flex",
  flexDirection: "column",
  paddingTop:"25px",
  paddingBottom:"20px",
  gap:"5px",
  justifyContent:"center",
  alignItems:"center",
  width:"100%",
}));

const EthContent = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "7px",
  alignItems:"end",
}));

const EthPriceText = styled(Typography)(({ theme }) => ({
  color: "#ffffff",
  fontSize: "25px",
  fontWeight: "bold",
}));

const EthText = styled(EthPriceText)(({ theme }) => ({
  fontSize: "17px",
  position:"relative",
  bottom:"4px",
}));

const PriceText = styled(Typography)(({ theme }) => ({
  color: "#ffffff",
  fontSize: "15px",
}));

interface cardsProps {
  ethPrice:number;
  price:number;
}

const FundDetailCards: React.FC<cardsProps> = ({ethPrice, price}) => {
  return (
    <Body>
      <EthContent>
        <EthPriceText>{ethPrice}</EthPriceText>
        <EthText>ETH</EthText>
      </EthContent>
      <PriceText>${price}</PriceText>
    </Body>
  );
};

export default FundDetailCards;
